import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { CaseService } from "./case-service";
import { RateLine } from "../../rates/_types/rate-line";
import { Case } from "./case";
import { Transaction } from "sip.js/lib/core";
import { Worker } from "../../workers/_types/worker";
import { Provider } from "@angular/core";

export class Job extends Resource {
    public override type = 'jobs';

    @prop()
    @required()
    public caseId!: string;
    public case!: Case;

    @prop()
    public caseServiceId!: string;

    public caseService!: CaseService;

    @prop()
    @required()
    public date: Date = new Date();

    @prop()
    public workerId!: string | null;

    public worker!: Worker;

    @prop()
    public rateLineId!: string;

    public rateLine!: RateLine;

    @prop()
    public rateLineDescription!: string;
    
    @prop()
    public code!: string;

    @prop()
    public description!: string;

    @prop()
    public rateLineUnitPrice!: number;

    @prop()
    public unitPrice!: number;

    @prop()
    public quantity!: number;
    
    @prop()
    public taxPercent: number = 21;

    @prop()
    public taxAmount!: number;

    @prop()
    public subtotal!: number;

    @prop()
    public total!: number;

    @prop()
    public isReview: boolean = false;

    @prop()
    public isBillable: boolean = false;

    @prop()
    public isForCompany: boolean = false;   
    
    @prop()
    public transactionId!: string;
    public transaction!: Transaction;

    @prop()
    public purchaseTransactionId?: string;
    public purchaseTransaction!: Transaction;

    @prop()
    public target!: string;

    @prop()
    public chargedByWorker: boolean = false;

    @prop()
    public chargedTransactionId!: string;
    public chargedTransaction!: Transaction;
    
    @prop()
    public jobCompanyDiscountPercent!: number;

    @prop()
    public jobGuardCompanyIncrementPercent!: number;

    @prop()
    public isIAGenerate: boolean = false;

    
    @prop()
    public providerId!: string;

    public provider!: Provider;

    @prop()
    public relatedInvoiceCode?: string;

    @prop()
    public relatedJobId!: string;

    @prop()
    public workerBillableItemLineId?: string;
}